// One relative-time formatter — previously copy-pasted into three pages,
// where the "ago" suffix had already drifted between columns.
export function relative(iso: string, opts: { suffix?: boolean } = {}): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000)
  const suffix = opts.suffix ? " ago" : ""
  if (minutes < 60) return `${Math.max(minutes, 0)} min${suffix}`
  if (minutes < 60 * 24) return `${Math.round(minutes / 60)} h${suffix}`
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" })
}

/** "1 room" / "3 rooms" — the inline `n === 1 ? … : …` idiom, named. */
export function pluralize(n: number, singular: string, plural = `${singular}s`): string {
  return `${n} ${n === 1 ? singular : plural}`
}
